import { useMutation, useQueryClient } from 'react-query';
import { ace_index_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { aceIndexKeys } from '../../cache-keys/aceIndexKeys';

export function useCreateWorkingList() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: ace_index_api.createWorkingList(api),
    onSuccess: () =>
      Promise.all([client.invalidateQueries(aceIndexKeys.workingLists())]),
  });
}
